// From https://svelte.dev/repl/de39de663ef2445b8fe17b79c500013b?version=3.44.2
// Svelte Quick Tip: Adding basic internationalization (i18n) to you app

import { derived, writable } from "svelte/store";
// import translations from "./translations";
import listOfLocales from "./localesIndex";

// TODO fetch the locale from teh URL somehow and then set the locale writable store to
// that locale if we have it in the list of locales.
const getLocaleFromURL = () => {

}

export const locale = writable("process.env.APP_LOCALE");
export const locales = Object.keys(listOfLocales);

// Load the translations.
const translations = {};

import t_ar from "./i18n/ar/messages-small.json";
import t_ca from "./i18n/ca/messages-small.json";
import t_de from "./i18n/de/messages-small.json";
import t_el from "./i18n/el/messages-small.json";
import t_en from "./i18n/en/messages-small.json";
import t_es from "./i18n/es/messages-small.json";
import t_fr from "./i18n/fr/messages-small.json";
import t_it from "./i18n/it/messages-small.json";
import t_ja from "./i18n/ja/messages-small.json";
import t_ms from "./i18n/ms/messages-small.json";
import t_nl from "./i18n/nl/messages-small.json";
import t_ptbr from "./i18n/pt_BR/messages-small.json";
import t_ro from "./i18n/ro/messages-small.json";
import t_ru from "./i18n/ru/messages-small.json";
import t_sv from "./i18n/sv/messages-small.json";
import t_tr from "./i18n/tr/messages-small.json";
import t_zhcn from "./i18n/zh_CN/messages-small.json";
import t_zhtw from "./i18n/zh_TW/messages-small.json";

translations["ar"] = t_ar;
translations["ca"] = t_ca;
translations["de"] = t_de;
translations["el"] = t_el;
translations["en"] = t_en;
translations["es"] = t_es;
translations["fr"] = t_fr;
translations["it"] = t_it;
translations["ja"] = t_ja;
translations["ms"] = t_ms;
translations["nl"] = t_nl;
translations["pt_BR"] = t_ptbr;
translations["ro"] = t_ro;
translations["ru"] = t_ru;
translations["sv"] = t_sv;
translations["tr"] = t_tr;
translations["zh_CN"] = t_zhcn;
translations["zh_TW"] = t_zhtw;

function translate(locale, key, vars) {
    // Let's throw some errors if we're trying to use keys/locales that don't exist.
    // We could improve this by using Typescript and/or fallback values.
    if (!key) throw new Error("no key provided to $t()");
    if (!locale) throw new Error(`no translation for key "${key}"`);

    // Grab the translation from the translations object.
    // translate returns message, description
    // message is the translated text.

    let text = "";
    text = translations[locale][key];
    if (!text) {
        locale = "en";
        console.error(`no translation for language ${locale} key "${key}"`);
        text = translations["en"][key];
    }
    if (!text) throw new Error(`no translation found for ${locale}.${key}`);
    // Replace any passed in variables in the translation string.
    Object.keys(vars).forEach((k) => { text = text.replace(k, vars[k]); });
    return text;
}

export const t = derived(locale, ($locale) => (key, vars = {}) => {
    return translate($locale, key, vars);
});
